import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

export default function CourseContentSwitch() {
    const [isActiveOnMenu, setIsActiveOnMenu] = useState(true)

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setIsActiveOnMenu(menuitem === 'video')
        }

        document.addEventListener('course_menu_tabs', listener)

        return () => {
            document.removeEventListener('course_menu_tabs', listener)
        }

    }, []);

    if(!isActiveOnMenu) return null;

    return (
        <MenuContainer>
            <Item>Videos</Item>
            <Item>Clases en directo</Item>
        </MenuContainer>
    )
}

const MenuContainer = styled.div`
    display: flex;
    flex-direction: row;
`

const Item = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    cursor: pointer;
`

if (document.getElementsByTagName('course-content-switch')) {
    const elms = document.getElementsByTagName('course-content-switch')

    for (let elm of elms) {
        ReactDOM.render(
            <CourseContentSwitch/>,
            elm
        );
    }
}
